import { render, staticRenderFns } from "./FamilyHubActivity.vue?vue&type=template&id=a2014bc2&scoped=true&"
import script from "./FamilyHubActivity.vue?vue&type=script&lang=ts&"
export * from "./FamilyHubActivity.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyHubActivity.vue?vue&type=style&index=0&id=a2014bc2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2014bc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBadge,VCardText,VCardTitle,VCol,VRow,VTab})
